import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { PickRoleName } from "../components/console/roles-page/RolesPage";

export const rolesSearchFiltersFields: Fields<PickRoleName> = {
    name: {
        min: 1,
        max: 50,
        placeholderKey: "console.users.table.role",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const rolesSearchFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, rolesSearchFiltersFields);
};
